import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';

import { InfoWorkZero } from 'assets/assetsV1/iconComponents';

import { Tooltip } from 'uiToolkitV1/Tooltip';

export const InputLabelTextWithInfoTooltip = React.memo(({ showInfoTooltip, labelText, tooltipText }) => {
  const theme = useTheme();

  return (
    <Tooltip fontSize="14px" label={showInfoTooltip ? tooltipText : ''}>
      <Flex>
        {labelText}
        {showInfoTooltip ? (
          <InfoWorkZero style={{ marginLeft: '5px' }} boxSize="18px" color={theme.colors.neutral['666666']} />
        ) : null}
      </Flex>
    </Tooltip>
  );
});
